import { useEffect, useRef, useState } from "react"
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _HelpDesk, _single, _Test } from "../../../core/services/dataBean/EntityCatalog";
import { PrintJson } from "../../theme/Component/PrintJson";
import { TestEncuesta } from "../../Talentohumano/ConfigTest/prueba/TestEncuesta";
import { Alert } from "../../theme/Component/Alert";
import { BasicButton } from "../../theme/Component/BasicButton";
import { toast } from "react-toastify";




interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}
export const TEST001 = ({ configProcedure }: Props) => {

    const [props, setProps] = useState<any>({});
    const { _procedure, _pocessData, _exportMap, _pushInfo, _pushProps } = configProcedure;
    const _helpDesk = useDataBean(_HelpDesk);
    const _test = useDataBean(_Test);
    const [test, setTest] = useState<any>([]);
    const response = useRef<any>();

    const { bean, setBean, handleChange } = _helpDesk;
    const account = _single.getAccount();

    useEffect(() => {
        if (_pocessData?.Props) {
            setProps(_pocessData?.Props)
        }

    }, [configProcedure?._pocessData])

    useEffect(() => {
        getTest();
    }, [props])

    

    const getTest = () => {
        if (props.idTest)
            _test.instance.getProofTestEvaluation(props.idTest).then(
                (resp: any) => {
                    setTest(resp);
                }
            )
    }
    const enviarEncuesta =()=>{

        _test.instance.setResponseProofTest(props.idTest,_single.getAccountID(),response.current).then(
            (resp:any)=>{
                toast.success("Respuestas enviadas.");                
                _single.printOut(resp);
            }
        )
            
        _pushInfo(
            _single.jsonToBootstrapTable({
            "Cierre":"Solicitud finalizada"
        })
        );
        _pushProps({
            Encuesta:JSON.stringify(response.current ?? '{}')
        })
        _exportMap({
            Encuesta:JSON.stringify(response.current)
        })
    }

    return (
        <div className="row">
            <div className="col-md-12">
                {props.idTest ?
                    <>
                    <TestEncuesta idTest={props.idTest} exportResult={(e) => { response.current = e }} />
                        <BasicButton icon="ri-mail-send-line" useMargin eventClick={enviarEncuesta}>Enviar</BasicButton>
                    </>
                    :
                    <Alert clase="primary">
                        <p>
                            El flujo no tiene una encuesta configurada
                        </p>
                    </Alert>
                }
            </div>
            <div className="col-md-12">

                {/* <PrintJson json={response.current} /> */}
            </div>
        </div>
    )
}